import { createAsyncThunk } from '@reduxjs/toolkit';

// Slices
import { BillingSliceActions } from './billing.slice';

// Services
import { BillingService } from '../../services/billing.service';

// Thunks
import { openNotification } from '../app-notifications/app-notifications.thunks';

export enum EBillingActions {
  FetchBillingBalance = 'BILLING/fetchBillingBalance',
}

export const fetchBillingBalance = createAsyncThunk(
    EBillingActions.FetchBillingBalance,
    async (_, { dispatch }: any) => {
      dispatch(BillingSliceActions.loadBillingBalanceRequest());
      const { balance, error } = await BillingService.fetchBillingBalance();
      if (!balance) {
        dispatch(openNotification({
          type: 'error',
          description: error ?? 'Can`t load billing balance. Please reload page and try again'
        }))
        dispatch(BillingSliceActions.loadBillingBalanceRequestError(error ?? 'Can`t load billing balance. Please reload page and try again'))
        return null;
      }
      dispatch(BillingSliceActions.loadBillingBalanceRequestSuccess(balance));
      return balance;
    }
  )
;
